module.exports = __webpack_public_path__ + "img/图片12.0b8b7d64.png";